import React, { useState } from 'react';
import AdaliaLogo from './AdaliaLogo';

/**
 * BrandLogo — affiche le LOGO OFFICIEL Adalia (image fournie par le cabinet, déposée
 * sous /public/branding) avec REPLI AUTOMATIQUE sur l'emblème vectoriel <AdaliaLogo/>
 * si le fichier est absent (build sans l'asset) → jamais d'image cassée.
 *
 * Props :
 *  - src             : chemin de l'image (sous /public, ex. "/branding/adalia-logo.png")
 *  - height          : hauteur affichée en px (largeur auto, ratio conservé)
 *  - alt             : texte alternatif (accessibilité)
 *  - fallbackVariant : 'full' | 'mark' — variante du repli SVG
 *  - fallbackColor   : couleur du mot dans le repli SVG
 *  - style           : styles complémentaires sur l'<img>
 */
export default function BrandLogo({
  src,
  height = 40,
  alt = 'Adalia — ERP Avocat',
  fallbackVariant = 'full',
  fallbackColor = 'var(--text-primary)',
  style,
}) {
  const [failed, setFailed] = useState(false);

  if (failed || !src) {
    return <AdaliaLogo size={height} variant={fallbackVariant} color={fallbackColor} />;
  }

  return (
    <img
      src={src}
      alt={alt}
      onError={() => setFailed(true)}
      style={{ height, width: 'auto', maxWidth: '100%', display: 'block', objectFit: 'contain', ...style }}
    />
  );
}
